// extracted by mini-css-extract-plugin
export default {"container":"RatingCalculator_container__Bp6S+"};